// removed by extract-text-webpack-plugin
module.exports = {"select-reason":"app-components-receipt-refunds-OldRefundTransactionModal-__oldRefundTransactionModal___9bplN","amount-reason":"app-components-receipt-refunds-OldRefundTransactionModal-__oldRefundTransactionModal___2tzwP","reason-for-refund":"app-components-receipt-refunds-OldRefundTransactionModal-__oldRefundTransactionModal___1KQuu","reason-field":"app-components-receipt-refunds-OldRefundTransactionModal-__oldRefundTransactionModal___1BtEN"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/refunds/OldRefundTransactionModal/oldRefundTransactionModal.css
// module id = 2011
// module chunks = 0